<template>
    <div class="card" @click="onClick">
      <div class="card-header-section">
        <span class="card-date">{{ date }}</span>
      </div>
      <h3 class="card-title">{{ title }}</h3>
      <p class="card-content">{{ content }}</p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'CommonCard',
    props: {
      title: {
        type: String,
        required: true
      },
      content: {
        type: String,
        required: true
      },
      date: {
        type: String,
        required: true
      },
      onClick: {
        type: Function,
        required: false,
        default: () => {}
      }
    }
  };
  </script>
  <style scoped>
  .card {
 
    background-color: #1e1e2f;
    border-radius: 10px;
    padding: 20px;
    color: #ffffff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
    min-width: 300px;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    transition: transform 0.2s ease;
  }
  .card:hover {
    transform: scale(1.02);
  }
  
  .card-header-section {
    padding: 0px;
    padding-inline: 0.5rem;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 1rem
  }
  
  .card-title {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
    color: #ffffff;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  
  .card-date {
    font-size: 12px;
    color: #888888;
  }
  
  .card-content {
    margin-top: 10px;
    font-size: 14px;
    color: #cccccc;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  </style>